// extracted by mini-css-extract-plugin
export default {"container":"a540ee7a841e"};